import { FourArrows } from "assets/website";
import { whyPrecisionImage } from "assets/images";

interface Benefit {
  title: string;
  description: string;
}

const benefits: Benefit[] = [
  {
    title: "Go Past Self-Reports",
    description: "Look beyond the CV & test real world knowledge application",
  },
  {
    title: "Assess for Context",
    description: "Role-based assessments & contextual evaluation",
  },
  {
    title: "One Assessment. Three Powers",
    description: "3-in-1 service – Hiring, talent management & Competence Audit",
  },
  {
    title: "Strengths & Gaps Insights",
    description: "Detailed reporting with actionable insights",
  },
];

const WhyPrecisionSection = () => {
  return (
    <section className="py-16 md:py-24 bg-[#000000]">
      <div className="container mx-auto xl:px-8 lg:px-4 px-4">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-16">
          <div
            data-aos="fade-up"
            className="inline-flex py-2 items-center gap-2 mb-4 relative before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-[1px] before:bg-[linear-gradient(90deg,rgba(198,224,255,0.4)_0%,#79A5F8_100%)] after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[1px] after:bg-[linear-gradient(90deg,rgba(198,224,255,0.4)_0%,#79A5F8_100%)]"
          >
            <FourArrows className="[&>path]:fill-white" />
            <span className="sm:text-lg text-base text-white tracking-wider">
              Reason
            </span>
          </div>
          <h2
            data-aos="fade-up"
            data-aos-delay="100"
            className="text-2xl md:text-4xl lg:text-5xl font-display font-bold text-white"
          >
            Why Precision
          </h2>
        </div>

        {/* Content: bullets left, image right */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-0 items-center">
          {/* Benefits list */}
          <div className="space-y-8">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-delay={100 + index * 80}
                className="flex items-start gap-4"
              >
                {/* Green tick circle */}
                <div className="flex-shrink-0 mt-0.5">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" fill="#49B144" />
                    <path
                      d="M7.5 12L10.5 15L16.5 9"
                      stroke="black"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-base md:text-lg lg:text-xl font-semibold text-white mb-1">
                    {benefit.title}
                  </h3>
                  <p className="text-sm md:text-base lg:text-lg text-[#98A2B3] leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Image */}
          <div
            data-aos="fade-up"
            data-aos-delay="200"
            className="flex items-center justify-center"
          >
            <img
              src={whyPrecisionImage}
              alt="Why Precision — 3D logo"
              className="w-full max-w-[620px] object-contain drop-shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export { WhyPrecisionSection };
